import { Injector, inject, runInInjectionContext } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, filter, of, switchMap } from 'rxjs';

import { selectPermissions } from '@core/stores/auth/auth.selectors';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

type PermissionRedirect = string[] | (() => Observable<RedirectCommand>);

export const createPermissionGuard =
  (permissions: PermissionStoreModelEnum | PermissionStoreModelEnum[], redirectPath: PermissionRedirect = ['/']): CanActivateFn =>
  () => {
    const store = inject(Store);
    const router = inject(Router);
    const injector = inject(Injector);
    const createRedirectCommand$ = () =>
      Array.isArray(redirectPath)
        ? of(new RedirectCommand(router.createUrlTree(redirectPath), { replaceUrl: true }))
        : runInInjectionContext(injector, () => redirectPath());

    return store.select(selectPermissions).pipe(
      filter((userPermissions) => !!userPermissions),
      switchMap((permissionsInStore) => {
        if (Array.isArray(permissions)) {
          return permissions.some((flag) => permissionsInStore.includes(flag)) ? of(true) : createRedirectCommand$();
        }

        return permissionsInStore.includes(permissions) ? of(true) : createRedirectCommand$();
      })
    );
  };
